import BaseFont, {
  FontUpdate,
} from 'client/components/core/Sidebar/components/Settings/components/Font/BaseFont'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'

export interface FontSelectorControlProps {
  update: (updatedFont: FontUpdate) => void
  labelText?: string
  hideLabel?: boolean
  globalFontFamily?: string | undefined
  mobileGlobalFontFamily?: string | undefined
  inheritedFontTypeLabel?: string
  isRootSetting?: boolean

  fontFamily: string | undefined
  mobileFontFamily: string | undefined
  fontWeight: string | undefined
  mobileFontWeight: string | undefined
  fontStyle: string | undefined
  mobileFontStyle: string | undefined
}

export const FontSelectorControl = ({
  update,
  labelText,
  hideLabel,
  globalFontFamily,
  mobileGlobalFontFamily,
  inheritedFontTypeLabel,
  isRootSetting,

  fontFamily,
  mobileFontFamily,
  fontWeight,
  mobileFontWeight,
  fontStyle,
  mobileFontStyle,
}: FontSelectorControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultFontFamily = getMobileOrDesktop(
    fontFamily,
    mobileFontFamily,
    isMobile,
  )
  const resultFontWeight = getMobileOrDesktop(
    fontWeight,
    mobileFontWeight,
    isMobile,
  )
  const resultFontStyle = getMobileOrDesktop(
    fontStyle,
    mobileFontStyle,
    isMobile,
  )
  const resultGlobalFontFamily = getMobileOrDesktop(
    globalFontFamily,
    mobileGlobalFontFamily,
    isMobile,
  )

  return (
    <BaseFont
      labelText={labelText}
      fontFamily={resultFontFamily}
      fontStyle={resultFontStyle}
      fontWeight={resultFontWeight}
      update={update}
      globalFontFamily={resultGlobalFontFamily}
      inheritedFontTypeLabel={inheritedFontTypeLabel}
      hideLabel={hideLabel}
      isRootSetting={isRootSetting}
    />
  )
}
